import { render, staticRenderFns } from "./programDates.vue?vue&type=template&id=379da858&"
import script from "./programDates.vue?vue&type=script&lang=js&"
export * from "./programDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports